import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/userDecorationRelation.ts
const userDecorationRelationSchema = z.object({
	id: z.string(),
	userId: z.string(),
	decorationId: z.string(),
	decorationType: z.string(),
	isEnabled: z.boolean(),
	obtainedAt: z.iso.datetime(),
	obtainedFrom: z.string(),
	userRemark: z.string().nullable().optional(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
});
const updateUserDecorationRelationInputSchema = z.object({
	id: z.coerce.bigint(),
	userRemark: z.string().min(1).max(30).nullable().optional()
});
const userDecorationRelationContract = oc.prefix("/user-decoration-relation").tag("UserDecorationRelation").router({
	getUserDecorationRelation: oc.route({
		method: "GET",
		path: "/{id}",
		summary: "Get user decoration relation by ID"
	}).input(z.object({ id: z.coerce.bigint() })).output(userDecorationRelationSchema).errors({
		NOT_FOUND: {
			status: 404,
			message: "User decoration relation not found"
		},
		FORBIDDEN: {
			status: 403,
			message: "Access denied"
		}
	}),
	updateUserDecorationRelation: oc.route({
		method: "PUT",
		path: "/{id}",
		summary: "Update user decoration relation"
	}).input(updateUserDecorationRelationInputSchema).output(userDecorationRelationSchema).errors({
		NOT_FOUND: {
			status: 404,
			message: "User decoration relation not found"
		},
		FORBIDDEN: {
			status: 403,
			message: "Access denied"
		}
	})
});
//#endregion
export { userDecorationRelationContract, userDecorationRelationSchema };
